var render, staticRenderFns
import script from "./discountCoupons.vue?vue&type=script&lang=js"
export * from "./discountCoupons.vue?vue&type=script&lang=js"
import style0 from "./discountCoupons.vue?vue&type=style&index=0&id=8a8bc656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8bc656",
  null
  
)

export default component.exports